function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.interestingSt0{fill:#FFBD59;}\n\t.interestingSt1{fill:#FFFFFF;}\n");

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  className: "interestingSt0",
  cx: 256,
  cy: 256,
  r: 256
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "interestingSt1",
  d: "M255.6,81c-69.7,0.2-119.9,56.7-119.9,120.3c0,29.1,10.5,57.3,29.8,79.2c11.3,12.9,29,39.8,35.7,62.5 c0,0.2,0,0.4,0.1,0.5h109.5c0-0.2,0-0.3,0.1-0.5c6.7-22.7,24.4-49.6,35.7-62.5c19.2-21.9,29.8-50,29.8-79.2 C376.3,134.8,322.3,80.8,255.6,81z M256,146.6c-30.2,0-54.7,24.5-54.7,54.7c0,6-4.9,10.9-10.9,10.9s-10.9-4.9-10.9-10.9 c0-42.3,34.3-76.5,76.6-76.6c6,0,10.9,4.9,10.9,10.9C266.9,141.7,262,146.6,256,146.6z"
});

var _ref5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "interestingSt1",
  points: "310.8,388.2 310.8,365.4 201.3,365.4 201.4,388.2  "
}), /*#__PURE__*/React.createElement("path", {
  className: "interestingSt1",
  d: "M208.1,408.2l8.7,13.1c3.6,5.4,11.7,9.8,18.2,9.8h42.2c6.5,0,14.6-4.4,18.2-9.8l8.7-13.1H208.1z"
}));

function SvgInterestingActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterestingActive);
export default __webpack_public_path__ + "static/media/interestingActive.9125a952.svg";
export { ForwardRef as ReactComponent };